<template>
  <q-dialog v-model="showModal" persistent>
    <q-card style="width: 800px; max-width: 90vw" class="q-pa-md">
      <q-card-section class="q-pb-none">
        <div class="row items-center text-h6 text-weight-bold text-brand-1">
          <span>Adicionar Contrato</span>
          <q-icon class="q-ml-sm" name="info" color="blue">
            <q-tooltip>
              Campos com <span class="text-negative">*</span> são obrigatórios
            </q-tooltip>
          </q-icon>
        </div>

        <q-btn
          flat
          round
          dense
          icon="close"
          class="absolute-top-right q-ma-sm"
          @click="fecharModal"
        />
      </q-card-section>

      <q-card-section class="q-pt-sm">
        <div class="row q-gutter-md">
          <!-- Unidade -->
          <div class="col-md-5 col-xs-12">
            <div class="text-brand-5 text-weight-bold q-mb-xs q-mt-md">
              Unidade <span class="text-negative">*</span>
            </div>
            <lista-unidades-select
              v-model="formData.unidade"
              class="input-new-design"
              :error="errors.unidade"
              :error-message="errorMessages.unidade"
            />
          </div>

          <!-- Fornecedor -->
          <div class="col-md-5 col-xs-12">
            <SelecaoFornecedorContrato
              :hidenLabel="true"
              :required="true"
              :labelSuperior="'Fornecedor'"
              @enviarFornecedor="receberFornecedor"
              class="input-new-design q-mt-lg"
            />
            <!-- Mostrar erro de validação -->
            <div
              v-if="errors.fornecedor"
              class="text-negative text-caption q-mt-xs"
            >
              {{ errorMessages.fornecedor }}
            </div>
          </div>
        </div>

        <div class="row q-gutter-md">
          <!-- Número Contrato -->
          <div class="col-md-5 col-xs-12">
            <div class="text-brand-5 text-weight-bold q-mb-xs q-mt-md">
              Número Contrato <span class="text-negative">*</span>
            </div>
            <q-input
              v-model="formData.numeroContrato"
              class="input-new-design"
              dense
              outlined
              placeholder="Digite o número do contrato"
              :error="errors.numeroContrato"
              :error-message="errorMessages.numeroContrato"
            />
          </div>

          <!-- Tipo Fornecimento -->
          <div class="col-md-5 col-xs-12">
            <div class="text-brand-5 text-weight-bold q-mb-xs q-mt-md">
              Tipo Fornecimento <span class="text-negative">*</span>
            </div>
            <q-select
              v-model="formData.tipoFornecimento"
              class="input-new-design"
              dense
              outlined
              use-input
              @filter="filterFn"
              :options="suppliesOptions"
              option-label="name"
              option-value="name"
              :display-value="
                formData?.tipoFornecimento?.name?.length > 28
                  ? `${formData?.tipoFornecimento?.name?.substring(0, 28)}..`
                  : formData?.tipoFornecimento?.name
              "
              :error="errors.tipoFornecimento"
              :error-message="errorMessages.tipoFornecimento"
            >
              <q-tooltip v-if="formData?.tipoFornecimento?.name">
                {{ formData?.tipoFornecimento?.name }}
              </q-tooltip>
            </q-select>
          </div>
        </div>

        <div class="row q-gutter-md">
          <!-- Data Início Contrato -->
          <div class="col-md-5 col-xs-12">
            <div class="text-brand-5 text-weight-bold q-mb-xs">
              Início Contrato <span class="text-negative">*</span>
            </div>
            <q-input
              v-model="formData.dataInicio"
              class="input-new-design"
              dense
              outlined
              mask="##/##/####"
              placeholder="dd/mm/aaaa"
              :error="errors.dataInicio"
              :error-message="errorMessages.dataInicio"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                      v-model="formData.dataInicio"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>

          <!-- Data Fim Contrato -->
          <div class="col-md-5 col-xs-12">
            <div class="text-brand-5 text-weight-bold q-mb-xs">
              Fim do Contrato <span class="text-negative">*</span>
            </div>
            <q-input
              v-model="formData.dataFim"
              class="input-new-design"
              dense
              outlined
              mask="##/##/####"
              placeholder="dd/mm/aaaa"
              :error="errors.dataFim"
              :error-message="errorMessages.dataFim"
            >
              <template v-slot:append>
                <q-icon name="event" class="cursor-pointer">
                  <q-popup-proxy
                    cover
                    transition-show="scale"
                    transition-hide="scale"
                  >
                    <q-date
                      :locale="myLocale"
                      mask="DD/MM/YYYY"
                      v-model="formData.dataFim"
                    >
                      <div class="row items-center justify-end">
                        <q-btn
                          v-close-popup
                          label="Fechar"
                          color="primary"
                          flat
                        />
                      </div>
                    </q-date>
                  </q-popup-proxy>
                </q-icon>
              </template>
            </q-input>
          </div>
        </div>

        <div class="row q-gutter-md">
          <!-- Valor Total Contrato -->
          <div class="col-md-5 col-xs-12">
            <div class="text-brand-5 text-weight-bold q-mb-xs">
              Valor Total Contrato (R$) <span class="text-negative">*</span>
            </div>
            <q-input
              v-model="formData.valorTotal"
              class="input-new-design"
              dense
              outlined
              prefix="R$"
              mask="#.###.###.###.###,##"
              reverse-fill-mask
              :error="errors.valorTotal"
              :error-message="errorMessages.valorTotal"
            />
          </div>

          <!-- Número Aditivo -->
          <div class="col-md-5 col-xs-12">
            <div class="text-brand-5 text-weight-bold q-mb-xs">
              Número Aditivo
            </div>
            <q-input
              v-model="formData.numeroAditivo"
              class="input-new-design"
              dense
              outlined
              type="number"
              min="0"
              placeholder="0"
            />
          </div>
        </div>

        <div class="row q-gutter-md">
          <!-- Observações -->
          <div class="col-12">
            <div class="text-brand-5 text-weight-bold q-mb-xs q-mt-md">
              Observações
            </div>
            <q-input
              v-model="formData.observacoes"
              class="input-new-design"
              dense
              outlined
              type="textarea"
              rows="3"
              placeholder="Digite as observações sobre o contrato"
            />
          </div>
        </div>
      </q-card-section>

      <q-card-actions align="right" class="q-pt-none">
        <q-btn
          flat
          label="Cancelar"
          color="negative"
          @click="fecharModal"
          no-caps
          class="q-mr-sm"
        />
        <q-btn
          flat
          icon="done"
          label="Criar Contrato"
          color="positive"
          no-caps
          @click="criarContrato"
          :loading="loading"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
import { ref, computed, watch, onMounted } from "vue";
import { useStore } from "vuex";
import { useQuasar } from "quasar";
import SelecaoFornecedorContrato from "./SelecaoFornecedorContrato.vue";
import ListaUnidadesSelect from "../../organizacional/unidade/component/ListaUnidadesSelect.vue";
import { useRouter } from "vue-router";

export default {
  name: "ModalAdicionarContrato",
  components: {
    SelecaoFornecedorContrato,
    ListaUnidadesSelect,
  },
  props: {
    modelValue: {
      type: Boolean,
      default: false,
    },
  },
  emits: ["update:modelValue", "contratoCreated"],
  setup(props, { emit }) {
    // Composables
    const store = useStore();
    const $q = useQuasar();

    //router
    const router = useRouter();

    // Refs
    const loading = ref(false);
    const centroOptions = ref([]);
    const suppliesOptions = ref([]);
    const time = ref(null);

    // Computed para controlar o modal
    const showModal = computed({
      get() {
        return props.modelValue;
      },
      set(value) {
        emit("update:modelValue", value);
      },
    });

    // Dados do formulário
    const formData = ref({
      unidade: null,
      fornecedor: null,
      numeroContrato: "",
      tipoFornecimento: null,
      dataInicio: "",
      dataFim: "",
      valorTotal: "",
      numeroAditivo: 0,
      observacoes: "",
    });

    // Validações
    const errors = ref({
      unidade: false,
      fornecedor: false,
      numeroContrato: false,
      tipoFornecimento: false,
      dataInicio: false,
      dataFim: false,
      valorTotal: false,
    });

    const errorMessages = ref({
      unidade: "",
      fornecedor: "",
      numeroContrato: "",
      tipoFornecimento: "",
      dataInicio: "",
      dataFim: "",
      valorTotal: "",
    });

    // Opções dos selects - removidas as não utilizadas

    // Locale para datas
    const myLocale = {
      days: "Domingo_Segunda_Terça_Quarta_Quinta_Sexta_Sábado".split("_"),
      daysShort: "Dom_Seg_Ter_Quar_Quin_Sex_Sáb".split("_"),
      months:
        "Janeiro_Fevereiro_Março_Abril_Maio_Junho_Julho_Agosto_Setembro_Outubro_Novembro_Dezembro".split(
          "_"
        ),
      monthsShort: "Jan_Fev_Mar_Abr_Mai_Jun_Jul_Ago_Set_Out_Nov_Dez".split("_"),
      firstDayOfWeek: 1,
    };

    // Métodos
    const fecharModal = () => {
      limparFormulario();
      showModal.value = false;
    };

    const limparFormulario = () => {
      formData.value = {
        unidade: null,
        fornecedor: null,
        numeroContrato: "",
        tipoFornecimento: null,
        dataInicio: "",
        dataFim: "",
        valorTotal: "",
        numeroAditivo: 0,
        observacoes: "",
      };

      // Limpar erros
      Object.keys(errors.value).forEach((key) => {
        errors.value[key] = false;
        errorMessages.value[key] = "";
      });
    };

    const validarFormulario = () => {
      let valido = true;

      // Limpar erros anteriores
      Object.keys(errors.value).forEach((key) => {
        errors.value[key] = false;
        errorMessages.value[key] = "";
      });

      // Validar fornecedor
      if (!formData.value.fornecedor) {
        errors.value.fornecedor = true;
        errorMessages.value.fornecedor = "Campo obrigatório";
        valido = false;
      }

      // Validar número do contrato
      if (!formData.value.numeroContrato.trim()) {
        errors.value.numeroContrato = true;
        errorMessages.value.numeroContrato = "Campo obrigatório";
        valido = false;
      }

      // Validar tipo de fornecimento
      if (!formData.value.tipoFornecimento) {
        errors.value.tipoFornecimento = true;
        errorMessages.value.tipoFornecimento = "Campo obrigatório";
        valido = false;
      }

      // Validar valor total
      if (!formData.value.valorTotal.trim()) {
        errors.value.valorTotal = true;
        errorMessages.value.valorTotal = "Campo obrigatório";
        valido = false;
      }

      // Validar data início
      if (!formData.value.dataInicio.trim()) {
        errors.value.dataInicio = true;
        errorMessages.value.dataInicio = "Campo obrigatório";
        valido = false;
      }

      // Validar data fim
      if (!formData.value.dataFim.trim()) {
        errors.value.dataFim = true;
        errorMessages.value.dataFim = "Campo obrigatório";
        valido = false;
      }

      // Validar se data fim é maior que data início
      if (formData.value.dataInicio && formData.value.dataFim) {
        // Verificar se as datas estão no formato correto (dd/mm/yyyy)
        const regexData = /^\d{2}\/\d{2}\/\d{4}$/;

        if (!regexData.test(formData.value.dataInicio)) {
          errors.value.dataInicio = true;
          errorMessages.value.dataInicio =
            "Formato de data inválido (dd/mm/aaaa)";
          valido = false;
        }

        if (!regexData.test(formData.value.dataFim)) {
          errors.value.dataFim = true;
          errorMessages.value.dataFim = "Formato de data inválido (dd/mm/aaaa)";
          valido = false;
        }

        // Se ambas as datas estão no formato correto, comparar
        if (
          regexData.test(formData.value.dataInicio) &&
          regexData.test(formData.value.dataFim)
        ) {
          const [diaInicio, mesInicio, anoInicio] = formData.value.dataInicio
            .split("/")
            .map(Number);
          const [diaFim, mesFim, anoFim] = formData.value.dataFim
            .split("/")
            .map(Number);

          // Validar se as datas são válidas
          const dataInicio = new Date(anoInicio, mesInicio - 1, diaInicio);
          const dataFim = new Date(anoFim, mesFim - 1, diaFim);

          // Verificar se as datas construídas correspondem aos valores inseridos
          if (
            dataInicio.getDate() !== diaInicio ||
            dataInicio.getMonth() !== mesInicio - 1 ||
            dataInicio.getFullYear() !== anoInicio
          ) {
            errors.value.dataInicio = true;
            errorMessages.value.dataInicio = "Data de início inválida";
            valido = false;
          }

          if (
            dataFim.getDate() !== diaFim ||
            dataFim.getMonth() !== mesFim - 1 ||
            dataFim.getFullYear() !== anoFim
          ) {
            errors.value.dataFim = true;
            errorMessages.value.dataFim = "Data de fim inválida";
            valido = false;
          }

          // Comparar as datas apenas se ambas são válidas
          if (
            dataInicio.getTime() === dataInicio.getTime() &&
            dataFim.getTime() === dataFim.getTime()
          ) {
            // Comparar primeiro o ano
            if (anoFim < anoInicio) {
              errors.value.dataFim = true;
              errorMessages.value.dataFim =
                "Data fim deve ser maior que data início";
              valido = false;
            }
            // Se o ano for igual, comparar o mês
            else if (anoFim === anoInicio && mesFim < mesInicio) {
              errors.value.dataFim = true;
              errorMessages.value.dataFim =
                "Data fim deve ser maior que data início";
              valido = false;
            }
            // Se ano e mês forem iguais, comparar o dia
            else if (
              anoFim === anoInicio &&
              mesFim === mesInicio &&
              diaFim <= diaInicio
            ) {
              errors.value.dataFim = true;
              errorMessages.value.dataFim =
                "Data fim deve ser maior que data início";
              valido = false;
            }
          }
        }
      }

      return valido;
    };

    const criarContrato = async () => {
      if (!validarFormulario()) {
        console.log(errors.value);
        $q.notify({
          message: "Por favor, corrija os campos com erro",
          color: "negative",
          position: "top",
          timeout: 3000,
        });
        return;
      }

      // Mostrar confirmação
      $q.dialog({
        title: "Confirmação",
        message: "Tem certeza que deseja criar esse contrato?",
        cancel: true,
        persistent: true,
      }).onOk(async () => {
        loading.value = true;

        try {
          // Preparar dados para o POST

          const contratoData = {
            providerId: formData.value.fornecedor.id,
            contractNumber: formData.value.numeroContrato,
            startDate: formatDateToISO(formData.value.dataInicio),
            endDate: formatDateToISO(formData.value.dataFim),
            totalValue: parseFloat(
              formData.value.valorTotal
                .replace(/[R$.\s]/g, "")
                .replace(",", ".")
            ),
            supplyName: formData.value.tipoFornecimento.name,
            aditiveNumbers: parseInt(formData.value.numeroAditivo) || 0,
            observations: formData.value.observacoes || null,
          };

          // Criar o contrato
          const responseContrato = await store.dispatch(
            "gdcStore/criarContrato",
            contratoData
          );

          // Se o contrato foi criado com sucesso, vincular a unidade
          if (responseContrato.data && responseContrato.data.result) {
            const contratoId = responseContrato.data.result.id;
            console.log(formData.value.unidade);
            const vendorsIds = [formData.value.unidade.id];

            await store.dispatch("gdcStore/vincularVendorContrato", {
              contratoId,
              vendorsIds,
            });
          }

          emit("contratoCreated", { ...formData.value });

          $q.notify({
            message: "Contrato criado com sucesso!",
            color: "positive",
            position: "bottom",
            timeout: 3000,
            icon: "check_circle",
          });

          fecharModal();

          router.push({
            name: "detalhe-contrato",
            params: { id: responseContrato.data.result.id },
          });
        } catch (error) {
          console.error("Erro ao criar contrato:", error);

          let errorMessage = "Erro ao criar contrato. Tente novamente.";

          // Tratar mensagens de erro em inglês
          if (
            error.response &&
            error.response.data &&
            error.response.data.message
          ) {
            const backendMessage = error.response.data.message;

            // Traduzir mensagens comuns do backend
            if (backendMessage.toLowerCase().includes("validation")) {
              errorMessage =
                "Erro de validação. Verifique os dados informados.";
            } else if (backendMessage.toLowerCase().includes("duplicate")) {
              errorMessage = "Já existe um contrato com este número.";
            } else if (backendMessage.toLowerCase().includes("provider")) {
              errorMessage = "Erro relacionado ao fornecedor selecionado.";
            } else if (backendMessage.toLowerCase().includes("unauthorized")) {
              errorMessage = "Você não tem permissão para criar contratos.";
            }
          }

          $q.notify({
            message: errorMessage,
            color: "negative",
            position: "bottom",
            timeout: 5000,
          });
        } finally {
          loading.value = false;
        }
      });
    };

    // Função auxiliar para formatar data
    const formatDateToISO = (dateString) => {
      if (!dateString) return null;
      const [day, month, year] = dateString.split("/");
      return `${year}-${month}-${day}`;
    };

    // Carregar lista de tipos de fornecimento
    const carregarSupplies = async (val) => {
      try {
        const response = await store.dispatch("gdcStore/getSupplies", {
          name: val,
        });
        suppliesOptions.value = response.data.result.data || [];
      } catch (error) {
        console.error("Erro ao carregar tipos de fornecimento:", error);
      }
    };

    const getCentros = async (val) => {
      try {
        const response = await store.dispatch("pkg/getCentrosCustos", {
          search: val,
        });
        centroOptions.value = response.data.results.data;
      } catch (error) {
        console.error("Erro ao buscar centros de custo:", error);
      }
    };

    const filterCenter = (val, update, abort) => {
      clearTimeout(time.value);

      if (val.length < 1) {
        abort();
        return;
      }

      time.value = setTimeout(() => {
        getCentros(val);
      }, 300);

      setTimeout(() => {
        update();
      }, 500);
    };

    const receberFornecedor = (fornecedor) => {
      formData.value.fornecedor = fornecedor;
    };

    // Watcher para carregar supplies quando modal abrir
    watch(showModal, (newValue) => {
      if (newValue) {
        carregarSupplies();
      } else {
        setTimeout(() => {
          limparFormulario();
        }, 300);
      }
    });

    const getUnidade = () => {
      if (
        localStorage.unidade &&
        localStorage.unidade != null &&
        localStorage.unidade != "null"
      ) {
        let getunidade = localStorage.getItem("unidade");
        formData.value.unidade = JSON.parse(getunidade);
      }
    };

    onMounted(getUnidade);

    watch(
      () => store.state.org.unidadeData,
      () => {
        formData.value.unidade = store.state.org.unidadeData;
      }
    );

    const filterFn = (val, update) => {
      clearTimeout(time.value);
      time.value = setTimeout(() => {
        update(async () => {
          await carregarSupplies(val);
        });
      }, 300);
    };
    return {
      showModal,
      formData,
      errors,
      errorMessages,
      loading,
      suppliesOptions,
      centroOptions,
      myLocale,
      fecharModal,
      criarContrato,
      filterCenter,
      receberFornecedor,
      filterFn,
    };
  },
};
</script>

<style scoped>
.input-new-design .q-field--outlined .q-field__control {
  border-radius: 8px !important;
}

.input-new-design .q-field__control:before {
  border-radius: 8px !important;
}

/* Animação do modal */
.q-dialog__inner {
  padding: 16px;
}

/* Estilo para chips das unidades */
.q-chip {
  margin: 2px;
}

/* Responsividade melhorada */
@media (max-width: 600px) {
  .q-card {
    margin: 8px;
  }

  .col-md-5 {
    margin-bottom: 16px;
  }
}
</style>
